export default function reducer(
  state = {
    selected: {},
    list: [],
    count: {},
    params: {},
    timelog: {},
    toDelete: {},
  },
  action
) {
  switch (action.type) {
    case 'SET_SELECTED_ACTION': {
      return { ...state, selected: action.selected };
    }
    case 'SET_SELECTED_TIMELOG': {
      return { ...state, timelog: action.timelog };
    }
    case 'SET_TIMELOG_LIST': {
      return {
        ...state,
        list: action.list,
        count: action.count ? action.count : state.count,
      };
    }
    case 'SET_TIMELOG_DELETE': {
      return { ...state, toDelete: action.toDelete };
    }
    default:
      return state;
  }
}
